"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _productContext = require("./productContext");
Object.keys(_productContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productContext[key];
    }
  });
});
//# sourceMappingURL=index.js.map